$(document).ready(function () {

    $('.feedback__photo-button').on('click', function () {
        $('.hidden-input').click();
    });

    $("#request-phone").mask(
        "+7 (999) 999-9999"
    );

    $('.hidden-input').on('change', function () {
        var input = $(this);
        var images = $('.feedback__photo-images img');
        $.each(images, function (key, value) {
            var img = $(this);
            var image = input[0].files[key];
            if (image && image.type.match('image.*')) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    img.attr('src', e.target.result);
                };
                reader.readAsDataURL(image);
            } else {
                img.attr('src', 'http://placehold.it/75x105/');
            }
        });
    });

    $('#cloud-item__header').on('click', function () {
        var elem = $(this);
        elem.toggleClass("cloud-item__header_up");
        elem.toggleClass("cloud-item__header_down");
        var cloud = $(this).parents('.cloud-item');
        cloud.toggleClass('height-limit');
    });


    $("#requestBtn").on("click", function (event) {
        event.preventDefault();
        let id = $(this).attr("href"),
            top = $(id).offset().top;
        $("body,html").animate({scrollTop: top}, 1500);
    });


    $('.rating li.rating__star').on('click', function () {
        var index = $(this).index();
        console.log(index);

        $(this).parent().find('li.rating__star')
            .removeClass('active');

        for (var i = 1; i <= index + 1; i++) {
            var li = $(this).parent().find('li:nth-child(' + i + ')');
            li.addClass('active');
        }
        $('.reviews-rating').val(index + 1);
    });

    var body = $('body');
    body.on('click', '.next-gallery', function () {
        $('.slick-lightbox-close').click();
        var elem = $(this);
        var id = elem.attr('data-gallery');
        $('[data-id="' + id + '"]').find('a:first-child').click();

        return false;
    });

    body.on('click', '.prev-gallery', function () {
        $('.slick-lightbox-close').click();
        var elem = $(this);
        var id = elem.attr('data-gallery');
        $('[data-id="' + id + '"]').find('a:first-child').click();

        return false;
    });
});